// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import { DropCodeCellItem_TlivFragmentDoc } from '../../developments/product-offerings/components/DropCodeCell.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanBasedBidsTable_AggregateVersionsQueryVariables = Types.Exact<{
  bidPackageVersionId: Types.Scalars['ID']['input'];
}>;


export type PlanBasedBidsTable_AggregateVersionsQuery = { __typename?: 'Query', bidPackageVersion: { __typename?: 'BidPackageVersion', id: string, readyPlanAggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, displayName: string, readyPlan:
        | { __typename?: 'ReadyPlan', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string }, globalOption: { __typename?: 'GlobalOption', id: string }, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, groupByFeature: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }> }
        | { __typename?: 'PlanPackage', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string }, globalOption: { __typename?: 'GlobalOption', id: string }, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, groupByFeature: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }> }
        | { __typename?: 'DesignPackage', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string }, globalOption: { __typename?: 'GlobalOption', id: string }, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, groupByFeature: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }> }
        | { __typename?: 'ProductOffering', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string }, globalOption: { __typename?: 'GlobalOption', id: string }, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, groupByFeature: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }> }
       }> } };

export type PlanBasedBidsTable_ScopeLinesQueryVariables = Types.Exact<{
  bidPackageVersionId: Types.Scalars['ID']['input'];
  highlightChanges: Types.Scalars['Boolean']['input'];
  filter: Types.BpvScopeLinesFilter;
}>;


export type PlanBasedBidsTable_ScopeLinesQuery = { __typename?: 'Query', bidPackageVersion: { __typename?: 'BidPackageVersion', id: string, previous?: { __typename?: 'BidPackageVersion', id: string, latestBidContractRevisions: Array<{ __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined }, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, bidItem?: { __typename?: 'BidItem', id: string } | null | undefined, itemTemplateItem?:
            | { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }
            | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }
            | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }
            | { __typename?: 'TakeoffLineItemVersion', id: string, identity: { __typename?: 'TakeoffLineItem', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }
           | null | undefined }> }> } | null | undefined }, bidPackageVersionScopeLines: Array<{ __typename?: 'BidPackageScopeLine', changeType?: string | null | undefined, takeoffLineItemVersion: { __typename?: 'TakeoffLineItemVersion', quantity?: number | null | undefined, id: string, name: string, identity: { __typename?: 'TakeoffLineItem', id: string }, bidItem?: { __typename?: 'BidItem', id: string, parentMaterialVariant?: { __typename?: 'MaterialVariant', id: string, code: string } | null | undefined } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, shortName: string, useQuantity: boolean }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, location: { __typename?: 'Location', id: string, displayLocationPath: string }, costEstimate: { __typename?: 'CostEstimate', costInCents: number }, drop?: { __typename?: 'Drop', id: string, code: string, name: string } | null | undefined, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, number: string, name: string } } }, previous?: { __typename?: 'TakeoffLineItemVersion', id: string, quantity?: number | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, drop?: { __typename?: 'Drop', id: string } | null | undefined, location: { __typename?: 'Location', id: string, displayLocationPath: string } } | null | undefined }> };

export type PlanBasedBidsTable_ScopeLinesFragment = { __typename?: 'BidPackageScopeLine', changeType?: string | null | undefined, takeoffLineItemVersion: { __typename?: 'TakeoffLineItemVersion', quantity?: number | null | undefined, id: string, name: string, identity: { __typename?: 'TakeoffLineItem', id: string }, bidItem?: { __typename?: 'BidItem', id: string, parentMaterialVariant?: { __typename?: 'MaterialVariant', id: string, code: string } | null | undefined } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, shortName: string, useQuantity: boolean }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, location: { __typename?: 'Location', id: string, displayLocationPath: string }, costEstimate: { __typename?: 'CostEstimate', costInCents: number }, drop?: { __typename?: 'Drop', id: string, code: string, name: string } | null | undefined, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, number: string, name: string } } }, previous?: { __typename?: 'TakeoffLineItemVersion', id: string, quantity?: number | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, drop?: { __typename?: 'Drop', id: string } | null | undefined, location: { __typename?: 'Location', id: string, displayLocationPath: string } } | null | undefined };

export type PlanBasedBidsTable_BidPackageVersionFragment = { __typename?: 'BidPackageVersion', id: string, previous?: { __typename?: 'BidPackageVersion', id: string, latestBidContractRevisions: Array<{ __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined }, lineItems: Array<{ __typename?: 'BidContractLineItem', id: string, totalCostInCents: number, bidItem?: { __typename?: 'BidItem', id: string } | null | undefined, itemTemplateItem?:
          | { __typename?: 'ItemTemplateItemVersion', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }
          | { __typename?: 'ItemTemplateItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }
          | { __typename?: 'TakeoffLineItem', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }
          | { __typename?: 'TakeoffLineItemVersion', id: string, identity: { __typename?: 'TakeoffLineItem', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }
         | null | undefined }> }> } | null | undefined };

export type PlanBasedBidsTable_TakeoffLineItemVersionFragment = { __typename?: 'TakeoffLineItemVersion', quantity?: number | null | undefined, id: string, name: string, identity: { __typename?: 'TakeoffLineItem', id: string }, bidItem?: { __typename?: 'BidItem', id: string, parentMaterialVariant?: { __typename?: 'MaterialVariant', id: string, code: string } | null | undefined } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, shortName: string, useQuantity: boolean }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, location: { __typename?: 'Location', id: string, displayLocationPath: string }, costEstimate: { __typename?: 'CostEstimate', costInCents: number }, drop?: { __typename?: 'Drop', id: string, code: string, name: string } | null | undefined, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, number: string, name: string } } };

export type PlanBasedBidsTable_PreviousTakeoffLineItemVersionFragment = { __typename?: 'TakeoffLineItemVersion', id: string, quantity?: number | null | undefined, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, drop?: { __typename?: 'Drop', id: string } | null | undefined, location: { __typename?: 'Location', id: string, displayLocationPath: string } };

export type PlanBasedBidsTable_ReadyPlan_ReadyPlan_Fragment = { __typename?: 'ReadyPlan', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string }, globalOption: { __typename?: 'GlobalOption', id: string }, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, groupByFeature: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }> };

export type PlanBasedBidsTable_ReadyPlan_PlanPackage_Fragment = { __typename?: 'PlanPackage', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string }, globalOption: { __typename?: 'GlobalOption', id: string }, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, groupByFeature: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }> };

export type PlanBasedBidsTable_ReadyPlan_DesignPackage_Fragment = { __typename?: 'DesignPackage', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string }, globalOption: { __typename?: 'GlobalOption', id: string }, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, groupByFeature: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }> };

export type PlanBasedBidsTable_ReadyPlan_ProductOffering_Fragment = { __typename?: 'ProductOffering', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string }, globalOption: { __typename?: 'GlobalOption', id: string }, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, groupByFeature: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }> };

export type PlanBasedBidsTable_ReadyPlanFragment =
  | PlanBasedBidsTable_ReadyPlan_ReadyPlan_Fragment
  | PlanBasedBidsTable_ReadyPlan_PlanPackage_Fragment
  | PlanBasedBidsTable_ReadyPlan_DesignPackage_Fragment
  | PlanBasedBidsTable_ReadyPlan_ProductOffering_Fragment
;

export type PlanBasedBidsTable_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string }, globalOption: { __typename?: 'GlobalOption', id: string }, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, groupByFeature: boolean }, location?: { __typename?: 'Location', id: string, name: string } | null | undefined };

export const PlanBasedBidsTable_TakeoffLineItemVersionFragmentDoc = gql`
    fragment PlanBasedBidsTable_TakeoffLineItemVersion on TakeoffLineItemVersion {
  ...Named
  quantity
  identity {
    id
  }
  bidItem {
    id
    parentMaterialVariant {
      id
      code
    }
  }
  unitOfMeasure {
    id
    shortName
    useQuantity
  }
  materialVariant {
    id
  }
  options {
    id
  }
  location {
    id
    displayLocationPath
  }
  costEstimate {
    costInCents
  }
  ...DropCodeCellItem_TLIV
}
    ${NamedFragmentDoc}
${DropCodeCellItem_TlivFragmentDoc}`;
export const PlanBasedBidsTable_PreviousTakeoffLineItemVersionFragmentDoc = gql`
    fragment PlanBasedBidsTable_PreviousTakeoffLineItemVersion on TakeoffLineItemVersion {
  id
  quantity
  options {
    id
  }
  unitOfMeasure {
    id
  }
  materialVariant {
    id
  }
  drop {
    id
  }
  location {
    id
    displayLocationPath
  }
}
    `;
export const PlanBasedBidsTable_ScopeLinesFragmentDoc = gql`
    fragment PlanBasedBidsTable_ScopeLines on BidPackageScopeLine {
  takeoffLineItemVersion {
    ...PlanBasedBidsTable_TakeoffLineItemVersion
  }
  changeType
  previous @include(if: $highlightChanges) {
    ...PlanBasedBidsTable_PreviousTakeoffLineItemVersion
  }
}
    ${PlanBasedBidsTable_TakeoffLineItemVersionFragmentDoc}
${PlanBasedBidsTable_PreviousTakeoffLineItemVersionFragmentDoc}`;
export const PlanBasedBidsTable_BidPackageVersionFragmentDoc = gql`
    fragment PlanBasedBidsTable_BidPackageVersion on BidPackageVersion {
  id
  previous @include(if: $highlightChanges) {
    id
    latestBidContractRevisions {
      id
      bidContract {
        id
        tradePartner {
          ...Named
        }
      }
      lineItems {
        id
        bidItem {
          id
        }
        itemTemplateItem {
          id
          options {
            id
          }
          ... on TakeoffLineItemVersion {
            id
            identity {
              id
            }
          }
        }
        totalCostInCents
      }
    }
  }
}
    ${NamedFragmentDoc}`;
export const PlanBasedBidsTable_ReadyPlanOptionFragmentDoc = gql`
    fragment PlanBasedBidsTable_ReadyPlanOption on ReadyPlanOption {
  id
  name
  type {
    id
    name
  }
  globalOption {
    id
  }
  optionGroup {
    id
    groupByFeature
  }
  location {
    id
    name
  }
}
    `;
export const PlanBasedBidsTable_ReadyPlanFragmentDoc = gql`
    fragment PlanBasedBidsTable_ReadyPlan on ReadyPlanLike {
  ...Named
  options {
    ...PlanBasedBidsTable_ReadyPlanOption
  }
}
    ${NamedFragmentDoc}
${PlanBasedBidsTable_ReadyPlanOptionFragmentDoc}`;
export const PlanBasedBidsTable_AggregateVersionsDocument = gql`
    query PlanBasedBidsTable_AggregateVersions($bidPackageVersionId: ID!) {
  bidPackageVersion(id: $bidPackageVersionId) {
    id
    readyPlanAggregateVersions {
      ...DisplayNamed
      readyPlan {
        ...PlanBasedBidsTable_ReadyPlan
      }
    }
  }
}
    ${DisplayNamedFragmentDoc}
${PlanBasedBidsTable_ReadyPlanFragmentDoc}`;

/**
 * __usePlanBasedBidsTable_AggregateVersionsQuery__
 *
 * To run a query within a React component, call `usePlanBasedBidsTable_AggregateVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanBasedBidsTable_AggregateVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanBasedBidsTable_AggregateVersionsQuery({
 *   variables: {
 *      bidPackageVersionId: // value for 'bidPackageVersionId'
 *   },
 * });
 */
export function usePlanBasedBidsTable_AggregateVersionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanBasedBidsTable_AggregateVersionsQuery, PlanBasedBidsTable_AggregateVersionsQueryVariables> & ({ variables: PlanBasedBidsTable_AggregateVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanBasedBidsTable_AggregateVersionsQuery, PlanBasedBidsTable_AggregateVersionsQueryVariables>(PlanBasedBidsTable_AggregateVersionsDocument, options);
      }
export function usePlanBasedBidsTable_AggregateVersionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanBasedBidsTable_AggregateVersionsQuery, PlanBasedBidsTable_AggregateVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanBasedBidsTable_AggregateVersionsQuery, PlanBasedBidsTable_AggregateVersionsQueryVariables>(PlanBasedBidsTable_AggregateVersionsDocument, options);
        }
// @ts-ignore
export function usePlanBasedBidsTable_AggregateVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanBasedBidsTable_AggregateVersionsQuery, PlanBasedBidsTable_AggregateVersionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanBasedBidsTable_AggregateVersionsQuery, PlanBasedBidsTable_AggregateVersionsQueryVariables>;
export function usePlanBasedBidsTable_AggregateVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanBasedBidsTable_AggregateVersionsQuery, PlanBasedBidsTable_AggregateVersionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanBasedBidsTable_AggregateVersionsQuery | undefined, PlanBasedBidsTable_AggregateVersionsQueryVariables>;
export function usePlanBasedBidsTable_AggregateVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanBasedBidsTable_AggregateVersionsQuery, PlanBasedBidsTable_AggregateVersionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanBasedBidsTable_AggregateVersionsQuery, PlanBasedBidsTable_AggregateVersionsQueryVariables>(PlanBasedBidsTable_AggregateVersionsDocument, options);
        }
export type PlanBasedBidsTable_AggregateVersionsQueryHookResult = ReturnType<typeof usePlanBasedBidsTable_AggregateVersionsQuery>;
export type PlanBasedBidsTable_AggregateVersionsLazyQueryHookResult = ReturnType<typeof usePlanBasedBidsTable_AggregateVersionsLazyQuery>;
export type PlanBasedBidsTable_AggregateVersionsSuspenseQueryHookResult = ReturnType<typeof usePlanBasedBidsTable_AggregateVersionsSuspenseQuery>;
export type PlanBasedBidsTable_AggregateVersionsQueryResult = Apollo.QueryResult<PlanBasedBidsTable_AggregateVersionsQuery, PlanBasedBidsTable_AggregateVersionsQueryVariables>;
export const PlanBasedBidsTable_ScopeLinesDocument = gql`
    query PlanBasedBidsTable_ScopeLines($bidPackageVersionId: ID!, $highlightChanges: Boolean!, $filter: BPVScopeLinesFilter!) {
  bidPackageVersion(id: $bidPackageVersionId) {
    ...PlanBasedBidsTable_BidPackageVersion
  }
  bidPackageVersionScopeLines(id: $bidPackageVersionId, filter: $filter) {
    ...PlanBasedBidsTable_ScopeLines
  }
}
    ${PlanBasedBidsTable_BidPackageVersionFragmentDoc}
${PlanBasedBidsTable_ScopeLinesFragmentDoc}`;

/**
 * __usePlanBasedBidsTable_ScopeLinesQuery__
 *
 * To run a query within a React component, call `usePlanBasedBidsTable_ScopeLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanBasedBidsTable_ScopeLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanBasedBidsTable_ScopeLinesQuery({
 *   variables: {
 *      bidPackageVersionId: // value for 'bidPackageVersionId'
 *      highlightChanges: // value for 'highlightChanges'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePlanBasedBidsTable_ScopeLinesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanBasedBidsTable_ScopeLinesQuery, PlanBasedBidsTable_ScopeLinesQueryVariables> & ({ variables: PlanBasedBidsTable_ScopeLinesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanBasedBidsTable_ScopeLinesQuery, PlanBasedBidsTable_ScopeLinesQueryVariables>(PlanBasedBidsTable_ScopeLinesDocument, options);
      }
export function usePlanBasedBidsTable_ScopeLinesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanBasedBidsTable_ScopeLinesQuery, PlanBasedBidsTable_ScopeLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanBasedBidsTable_ScopeLinesQuery, PlanBasedBidsTable_ScopeLinesQueryVariables>(PlanBasedBidsTable_ScopeLinesDocument, options);
        }
// @ts-ignore
export function usePlanBasedBidsTable_ScopeLinesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanBasedBidsTable_ScopeLinesQuery, PlanBasedBidsTable_ScopeLinesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanBasedBidsTable_ScopeLinesQuery, PlanBasedBidsTable_ScopeLinesQueryVariables>;
export function usePlanBasedBidsTable_ScopeLinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanBasedBidsTable_ScopeLinesQuery, PlanBasedBidsTable_ScopeLinesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanBasedBidsTable_ScopeLinesQuery | undefined, PlanBasedBidsTable_ScopeLinesQueryVariables>;
export function usePlanBasedBidsTable_ScopeLinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanBasedBidsTable_ScopeLinesQuery, PlanBasedBidsTable_ScopeLinesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanBasedBidsTable_ScopeLinesQuery, PlanBasedBidsTable_ScopeLinesQueryVariables>(PlanBasedBidsTable_ScopeLinesDocument, options);
        }
export type PlanBasedBidsTable_ScopeLinesQueryHookResult = ReturnType<typeof usePlanBasedBidsTable_ScopeLinesQuery>;
export type PlanBasedBidsTable_ScopeLinesLazyQueryHookResult = ReturnType<typeof usePlanBasedBidsTable_ScopeLinesLazyQuery>;
export type PlanBasedBidsTable_ScopeLinesSuspenseQueryHookResult = ReturnType<typeof usePlanBasedBidsTable_ScopeLinesSuspenseQuery>;
export type PlanBasedBidsTable_ScopeLinesQueryResult = Apollo.QueryResult<PlanBasedBidsTable_ScopeLinesQuery, PlanBasedBidsTable_ScopeLinesQueryVariables>;